import { render, staticRenderFns } from "./ghTabsPage.vue?vue&type=template&id=29710a0a&scoped=true&"
import script from "./ghTabsPage.vue?vue&type=script&lang=js&"
export * from "./ghTabsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29710a0a",
  null
  
)

export default component.exports